import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-287a31f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rate-card" }
const _hoisted_2 = { class: "rate-card__name" }
const _hoisted_3 = { class: "rate-card__info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.name), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.rate?.toFixed(7)), 1)
  ]))
}